import he from "he"

/**
 * Convert a string to HTML entities
 */
export const toHtmlEntities = (str: string) => {
    return he.encode(str);
};


/**
 * Create string from HTML entities
 */
export const fromHtmlEntities = (str: string) => {
    return he.decode(str);
};